module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "liga-personal-brackets"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Duel")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/liga-personal'
      }
    }
  }, [_vm._v("Menu Liga Personal")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Brackets")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Bracket")]), _vm._v(" "), _c('div', [_c('bracket', {
    attrs: {
      "rounds": _vm.rounds
    },
    scopedSlots: _vm._u([{
      key: "player",
      fn: function(ref) {
        var player = ref.player;

        return [_vm._v("\n\t\t\t\t\t" + _vm._s(player.name) + "\n\t\t\t\t")]
      }
    }, {
      key: "player-extension-bottom",
      fn: function(ref) {
        var match = ref.match;

        return [_vm._v("\n\t\t\t\t\tExtra info: " + _vm._s(match.title) + "\n\t\t\t\t")]
      }
    }])
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0485a0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/duel/liga_personal/LigaPersonalBrackets.vue
// module id = 1392
// module chunks = 0